<template>
  <div class="page-opportunity-tabs" v-loading.fullscreen="loading" id="top">
    <!-- <div v-for="(block, index) in blocks" :key="`block-${index}`">
      <info-block :data="block"></info-block>
    </div> -->
    <div class="container is-gap-top color-lightgreen-bg" data-aos="fade-in" data-aos-once="true" id="top-main" v-if="!isOpen"
      style="min-height:300px;display:flex;flex-direction:column;justify-content:center;">
      This position is not currently available.
    </div>

    <div class="container is-gap-top section-top" v-if="isOpen"
      data-aos="fade-in"
      data-aos-once="true"
      id="top-main">
      <h1 style="text-align: left;">{{ dataJob && dataJob.title }}</h1>
      <hr />
      <div class="info-sections">
        <div class="info-section">
          <div class="info-rows" v-for="(infoRow, ir) in infoRows1" :key="`${ir}`">
            <div class="info-key">{{ infoRow.label }}</div>
            <div class="info-value">{{ getInfo(infoRow.id) }}</div>
          </div>
        </div>
        <div class="info-section">
          <div class="info-rows" v-for="(infoRow, ir) in (isService ? infoRows2 : infoRows2b)" :key="`${ir}`">
            <div class="info-key">{{ infoRow.label }}</div>
            <div class="info-value">{{ getInfo(infoRow.id) }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="container is-gap-top section-tabs" v-if="isOpen"
      data-aos="fade-in"
      data-aos-once="true"
      id="top-main">
      <tabs :tabs="tabs" :tab="tab" @change-tab="onChangeTab" />
    </div>

    <tab-info
      v-if="tab === 'info' && !_.isEmpty(dataJob) && isOpen"
      :data-job="dataJob"
    />

    <form-opening
      v-if="tab === 'apply' && !_.isEmpty(dataJob) && isOpen"
      :data-job="dataJob"
    />
  </div>
</template>

<script>
import _ from 'lodash'
import Constants from '@/constants'
// import OpeningFormConstants from '@/pages/opportunities/formopening/formconstants'
import Util from '@/util'
import ObjectUtil from '@/util/object'
// import StringUtil from '@/util/string'
// import FileUtil from '@/util/file'
import EventBus from '@/controllers/EventBus'
// import Site from '@/apis/site'
import SiteAims from '@/apis/aims'

import Tabs from '@/components/Tabs'
// import InfoBlock from '@/pages/base/infoblock'
// import Formm from '@/base/form'
import TabInfo from '@/pages/opportunities/tabs/tabinfo'
import FormOpening from '@/pages/opportunities/formopening'

// import File from '@/apis/file'
// import Upload from '@/apis/upload'

export default {
  name: 'page-opportunity-tabs',
  props: {
    // msg: String
  },
  components: {
    Tabs,
    // InfoBlock,
    // Formm,
    TabInfo,
    FormOpening,
  },
  data () {
    return {
      name: 'form-opening',
      loading: false,
      isDesktop: true,
      isDevOrLocal: (Constants.isDev || Constants.isLocalhost),
      dataJob: {},
      isOpen: true,
      isService: true,
      blocks: [],
      // tabs
      tabs: [{
        name: 'info',
        label: 'Job Description',
      }, {
        name: 'apply',
        label: 'Apply For This Position',
      }],
      tab: 'info',
      // info
      options: {},
      infoRows1: [{
        id: 'locationNames',
        label: 'Location',
      }, {
        id: 'employmentType.name',
        label: 'Employment Type',
      }, {
        id: 'positionType.name',
        label: 'Position Type',
      // }, {
      //   id: 'service.name',
      //   label: 'Service',
      // }, {
      //   id: 'compensation',
      //   label: 'Compensation',
      }],
      infoRows2: [{
        id: 'service.name',
        label: 'Service',
      }, {
        id: 'compensation',
        label: 'Compensation',
      }, {
        id: 'experienceLevel.name',
        label: 'Experience',
      }],
      infoRows2b: [{
        id: 'serviceType.name',
        label: 'Service Type',
      }, {
        id: 'compensation',
        label: 'Compensation',
      }, {
        id: 'experienceLevel.name',
        label: 'Experience',
      }],
    }
  },
  computed: {
    _: function () {
      return _
    },

    Util: function () {
      return Util
    },
  },
  watch: {
  },
  created () {
  },
  async mounted () {
    this.isDesktop = EventBus._isDesktop
    EventBus.$on('isDesktopChanged', function () {
      this.isDesktop = EventBus._isDesktop
    }.bind(this))

    // this.clear()
    // this.setRules()
    // this.load()
    await this.refresh()
  },
  methods: {
    onChangeTab (tab) {
      this.$set(this, 'tab', tab)
    },

    getInfo (key) {
      let value = ObjectUtil.get(this.dataJob, key)
      return value == null ? '' : value
    },

    async refresh () {
      try {
        this.$set(this, 'loading', true)
        // data
        let promises = []
        let promise
        promise = this.getJob()
        promises.push(promise)
        // promise = this.getEmploymentTypes()
        // promises.push(promise)
        // promise = this.getPositionTypes()
        // promises.push(promise)
        // promise = this.getExperienceLevels()
        // promises.push(promise)
        // promise = this.getCoordinators()
        // promises.push(promise)
        await Promise.all(promises)
        // await this.getBlocks()
        this.$set(this, 'loading', false)
      } catch (error) {
        this.$set(this, 'loading', false)
        this.$message({
          message: `Refresh failed: ${error.message || error}`,
          type: 'error'
        })
      }
    },

    async getJob () {
      this.$set(this, 'dataJob', {})
      let response = await SiteAims.getJob(this.$route.params.jobId)
      let data = (response && response.data) || {}
      data.stateNames = data.states != null ? _.map(data.states, (s) => s.name).join(', ') : ''
      data.locationNames = `${data.city != null && data.city.length > 0 ? `${data.city}, ` : ''}${data.stateNames}`
      if (data.serviceId == null) {
        this.$set(this, 'isService', false)
      }
      this.$set(this, 'dataJob', data)
      this.$set(this, 'isOpen', data.status === Constants.JobStatus.OPEN)
    },

    // async getEmploymentTypes () {
    //   let response = await SiteAims.getNominalData('employment_types')
    //   let data = (response && response.data) || []
    //   this.options.dataEmploymentTypes = _.map(data, (item) => {
    //     return {
    //       value: item.id,
    //       label: item.name,
    //     }
    //   })
    // },

    // async getPositionTypes () {
    //   let response = await SiteAims.getNominalData('position_types')
    //   let data = (response && response.data) || []
    //   this.options.dataPositionTypes = _.map(data, (item) => {
    //     return {
    //       value: item.id,
    //       label: item.name,
    //     }
    //   })
    // },

    // async getExperienceLevels () {
    //   let response = await SiteAims.getNominalData('experience_levels')
    //   let data = (response && response.data) || []
    //   this.options.dataExperienceLevels = _.map(data, (item) => {
    //     return {
    //       value: item.id,
    //       label: item.name,
    //     }
    //   })
    // },

    // async getCoordinators () {
    //   let response = await SiteAims.getNominalData('coordinators', { openingId: this.$route.params.jobId })
    //   let data = (response && response.data) || []
    //   this.options.dataCoordinators = _.map(data, (item) => {
    //     return {
    //       value: item.id,
    //       label: item.name,
    //     }
    //   })
    // },

    // async getBlocks () {
    //   this.$set(this, 'blocks', [])
    //   // let data = await Site.infoNamedLike('page-placement-form')
    //   // console.log(`${this.name}: data blocks`, data)
    //   let dataJob = this.dataJob || {}
    //   let data = [{
    //     title: `${dataJob.title} - ${dataJob.state && dataJob.state.name}`,
    //     description: 'Please fill in the form',
    //     // meta: '{"arrangement": "top-header", "content": { "style": { "width": "100%" } } }',
    //     meta: {
    //       arrangement: 'top-header',
    //       content: {
    //         style: {
    //           width: '100%',
    //         },
    //       },
    //     },
    //   }]
    //   this.$set(this, 'blocks', data)
    // },
  },
}
</script>

<style lang="scss" src="../../../styles/base.scss"></style>
<style scoped lang="scss">
@import "../../../styles/app_setting.scss";

.page-opportunity-tabs {
  .section-top {
    margin-top: 36px;
    @media screen and (max-width: ($desktop - 1)) {
      margin-left: 24px;
      margin-right: 24px;
    }
  }

  .info-sections {
    .info-section {
      margin-top: 12px;
      display: inline-block;
      width: 50%;
      vertical-align: top;
      @media screen and (max-width: $mobile) {
        display: block;
        width: 100%;
      }
    }
  }

  .section-tabs {
    margin-top: 36px;
  }

  .info-rows {
    display: flex;
    flex-direction: row;
    .info-key {
      flex: 2;
      // background-color: $color-primary;
      text-align: left;
      margin-top: 8px;
    }
    .info-value {
      flex: 3;
      text-align: left;
      margin-top: 8px;
    }
  }
}

</style>
